import useGlobalStore from '@/store/useGlobalStore'
import { useEffect, useState, useCallback } from 'react'
import type { PromoResponse } from '@/store/types/promo'
import { getProducts } from '@/lib/cms/getProducts'

export const useGetPromosProductData = () => {
  const { cart, app, setCartPromos } = useGlobalStore()
  const { locale } = app
  const [promoItems, setPromoItems] = useState<PromoResponse[] | undefined>()
  const [isLoading, setIsLoading] = useState(true)
  const addedLines = cart.addedLines?.items || []

  const addedLinesSkus = new Set(addedLines.map((line) => line.item.id.unicity))

  const filterPromos = useCallback(
    (products: PromoResponse[]) =>
      products.filter((item) => {
        const { sku } = item.data.variations[0]
        return sku && addedLinesSkus.has(sku)
      }),
    [addedLinesSkus],
  )

  const getPromos = useCallback(async () => {
    const products = await getProducts({
      locale,
    })

    if (!products || 'error' in products) {
      setIsLoading(false)
      return
    }

    if ('error' in products) {
      setIsLoading(false)
      return
    }

    // assuming that the promo items will only have on variation to them that holds its sku
    const promos = products?.filter((item) => {
      if (!item.variations) return false

      const { sku } = item.variations[0]

      if (sku) {
        return addedLinesSkus.has(sku)
      }

      return false
    })

    if (promos) {
      setCartPromos(promos.map((promo) => ({ data: promo })))
    }

    setPromoItems(promos.map((promo) => ({ data: promo })))
    setIsLoading(false)
  }, [locale, filterPromos, setCartPromos])

  useEffect(() => {
    getPromos().catch((error) =>
      console.error('Failed to fetch promos:', error),
    )
  }, [])

  return { promoItems, isLoading }
}
